/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrgInviteRequest
 */
export interface CreateOrgInviteRequest {
    /**
     * The email address of the user to invite.
     * @type {string}
     * @memberof CreateOrgInviteRequest
     */
    email: string;
}

/**
 * Check if a given object implements the CreateOrgInviteRequest interface.
 */
export function instanceOfCreateOrgInviteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function CreateOrgInviteRequestFromJSON(json: any): CreateOrgInviteRequest {
    return CreateOrgInviteRequestFromJSONTyped(json, false);
}

export function CreateOrgInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrgInviteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function CreateOrgInviteRequestToJSON(value?: CreateOrgInviteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

